__turbopack_context__.v({
  "brands-alphabet-list": "styles-module-scss-module__bBTNUq__brands-alphabet-list",
  "brands-alphabet-list__block": "styles-module-scss-module__bBTNUq__brands-alphabet-list__block",
  "brands-alphabet-list__list": "styles-module-scss-module__bBTNUq__brands-alphabet-list__list",
  "brands-alphabet-list__list-item": "styles-module-scss-module__bBTNUq__brands-alphabet-list__list-item",
  "brands-alphabet-list__title": "styles-module-scss-module__bBTNUq__brands-alphabet-list__title",
  "brands-alphabet-list__title--active": "styles-module-scss-module__bBTNUq__brands-alphabet-list__title--active",
});
